import { Box, Checkbox, Tooltip, Typography } from '@mui/material';
import { Info } from 'lucide-react';
import { useRecoilState } from 'recoil';
import { pseudonymizeState } from '~/state/atoms/viewerAtoms';

type PseudonymizeCheckboxProps = {
    disabled?: boolean;
};

const PseudonymizeCheckbox = ({
    disabled = false,
}: PseudonymizeCheckboxProps) => {
    const [pseudonymizeData, setPseudonymizeState] =
        useRecoilState(pseudonymizeState);

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="end"
            position="relative"
            ml={-1}
        >
            <Checkbox
                data-testid="pseudonymizeCheckbox"
                onChange={(_, checked) => setPseudonymizeState(checked)}
                size="small"
                color="primary"
                checked={pseudonymizeData}
                disabled={disabled}
            />
            <Typography variant="body2" fontSize={13} lineHeight={1} mr={2}>
                De-identify data
            </Typography>
            <Tooltip
                title={
                    <Box p={1} maxWidth={200} whiteSpace="normal">
                        <Typography variant="caption" color="inherit">
                            When enabled, patient data will be de-identified
                            before being sent for processing.
                        </Typography>

                        <Typography variant="body2" fontSize={11} mt={0.5}>
                            Select this if DICOM files contain patient
                            identitying information
                        </Typography>
                    </Box>
                }
                placement="right-start"
            >
                <Info
                    size={10}
                    style={{
                        position: 'absolute',
                        right: 0,
                        top: 4,
                    }}
                />
            </Tooltip>
        </Box>
    );
};

export default PseudonymizeCheckbox;
